import {
    IDeleteDepositFormUserDataActionPayload,
    IDepositAvailableMethod,
    IDepositAvailableMethods,
    IDepositCreateActionPayload,
    IDepositCreateSuccessPayload,
    IDepositError,
    IDepositFormDataListItem,
    IDepositFormUserDataResponse,
    IDepositParams,
    IDepositState,
    IGetDepositAvailableMethodsActionPayload,
    IGetDepositFormUserDataActionPayload,
    IGetDepositSurveyActionPayload,
    IGetDepositSurveySuccessPayload,
    ISendDepositSurveyActionPayload,
    ISetDepositFormUserDataActionPayload,
    IUpdateDepositTransactionStartPayload,
    TDepositStep,
} from './Deposit.t';
import { LOGOUT_SUCCESS } from '../Login/loginConstants';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DEPOSIT_PARAMS_INITIAL_STATE, DEPOSIT_STEPS } from './depositConstants';
import { IGetDepositFormPayload } from '../Account/types/Account.t';

import { IPaymentForm } from '../Payment/payment.t';
import { IUpdateDepositTransactionStartSuccessPayload } from '../../app/types/appActions.t';

const initialState: IDepositState = {
    availableMethods: [],
    availableMethodsLoading: false,
    depositCreateProcess: false,
    depositCreateSuccessPayload: null,
    depositParams: DEPOSIT_PARAMS_INITIAL_STATE,
    form: [],
    error: null,
    formDataList: [],
    formDataListError: null,
    formDataListIsLoading: false,
    formUserData: null,
    formUserDataError: null,
    formUserDataFormId: null,
    formUserDataIsLoading: false,
    formUserDataPaymentKey: null,
    incompleteDeposit: null,
    isCheckDepositSurvey: false,
    isIncompleteDepositVisible: false,
    isIncompleteDepositClosedByUser: false,
    step: DEPOSIT_STEPS.FILL_FORM,
};

const depositSlice = createSlice({
    name: 'deposit',
    initialState,
    reducers: {
        depositInitAction(state, action: PayloadAction) {
        },
        depositUnmountAction(state, action: PayloadAction) {
            state.step = initialState.step;
            state.depositCreateSuccessPayload = null;
        },

        getDepositAvailableMethodsAction(state, action: PayloadAction<IGetDepositAvailableMethodsActionPayload>) {
            state.error = null;
            state.availableMethodsLoading = true;
        },
        getDepositAvailableMethodsSuccess(state, action: PayloadAction<IDepositAvailableMethods>) {
            state.availableMethods = action.payload || [];
            state.availableMethodsLoading = false;
        },
        getDepositAvailableMethodsFailure(state, action: PayloadAction<IDepositError>) {
            state.error = action.payload;
            state.availableMethodsLoading = false;
        },

        getDepositFormAction(state, action: PayloadAction<IGetDepositFormPayload>) {
            state.depositCreateSuccessPayload = null;
        },
        getDepositFormSuccess(state, action: PayloadAction<IPaymentForm>) {
            state.form = action.payload;
        },
        getDepositFormFailure(state, action: PayloadAction<IDepositError>) {
            state.error = action.payload;
        },

        depositCreateAction(state, action: PayloadAction<IDepositCreateActionPayload>) {
            state.error = null;
            state.depositCreateSuccessPayload = null;
            state.depositCreateProcess = true;
        },
        depositCreateSuccess(state, action: PayloadAction<IDepositCreateSuccessPayload>) {
            state.depositCreateSuccessPayload = action.payload;
            state.depositCreateProcess = false;
        },
        depositCreateFailure(state, action: PayloadAction<IDepositError>) {
            state.error = action.payload;
            state.depositCreateProcess = false;
        },

        updateDepositTransactionAction(state, action: PayloadAction<IUpdateDepositTransactionStartPayload>) {
        },
        updateDepositTransactionSuccess(state, action: PayloadAction<IUpdateDepositTransactionStartSuccessPayload>) {
            if (!state.depositCreateSuccessPayload) {
                state.depositCreateSuccessPayload = {};
            }
            state.depositCreateSuccessPayload.transaction = action.payload.transaction;
            state.depositCreateSuccessPayload.bonus = action.payload.bonus;
            state.depositCreateSuccessPayload.account_promocode = action.payload.account_promocode;
        },
        updateDepositTransactionFailure(state, action: PayloadAction<IDepositError>) {
        },

        initDepositPaymentFormAction(state, action: PayloadAction<IDepositAvailableMethod>) {
        },

        handleDepositFormUnmountAction(state, action: PayloadAction) {
        },

        getDepositParamsAction(state, action: PayloadAction) {
        },
        getDepositParamsSuccess(state, action: PayloadAction<IDepositParams>) {
            state.depositParams = action.payload;
        },
        getDepositParamsFailure(state, action: PayloadAction) {
        },

        getDepositFormDataListAction(state, action: PayloadAction) {
            state.formDataListError = null;
            state.formDataListIsLoading = true;
        },
        getDepositFormDataListSuccess(state, action: PayloadAction<IDepositFormDataListItem[]>) {
            state.formDataList = action.payload;
            state.formDataListIsLoading = false;
        },
        getDepositFormDataListFailure(state, action: PayloadAction<string>) {
            state.formDataListError = action.payload;
            state.formDataListIsLoading = false;
        },

        getDepositFormUserDataAction(state, action: PayloadAction<IGetDepositFormUserDataActionPayload>) {
            state.formUserDataError = null;
            state.formUserDataIsLoading = true;
        },
        getDepositFormUserDataSuccess(state, action: PayloadAction<IDepositFormUserDataResponse>) {
            state.formUserData = action.payload.form_data;
            state.formUserDataFormId = action.payload.form_id;
            state.formUserDataIsLoading = false;
            state.formUserDataPaymentKey = action.payload.payment_key;
        },
        getDepositFormUserDataFailure(state, action: PayloadAction<string>) {
            state.formUserDataError = action.payload;
            state.formUserDataIsLoading = false;
        },

        setDepositFormUserDataAction(state, action: PayloadAction<ISetDepositFormUserDataActionPayload>) {
            state.formUserDataError = null;
            state.formUserDataIsLoading = true;
        },
        setDepositFormUserDataSuccess(state, action: PayloadAction<IDepositFormUserDataResponse>) {
            state.formUserData = action.payload.form_data;
            state.formUserDataFormId = action.payload.form_id;
            state.formUserDataIsLoading = false;
            state.formUserDataPaymentKey = action.payload.payment_key;
        },
        setDepositFormUserDataFailure(state, action: PayloadAction<string>) {
            state.formUserDataError = action.payload;
            state.formUserDataIsLoading = false;
        },

        deleteDepositFormUserDataAction(state, action: PayloadAction<IDeleteDepositFormUserDataActionPayload>) {
        },
        deleteDepositFormUserDataSuccess(state, action: PayloadAction) {
        },
        deleteDepositFormUserDataFailure(state, action: PayloadAction<string>) {
        },

        getDepositSurveyAction(state, action: PayloadAction<IGetDepositSurveyActionPayload>) {
        },
        getDepositSurveySuccess(state, action: PayloadAction<IGetDepositSurveySuccessPayload>) {
        },
        getDepositSurveyFailure(state, action: PayloadAction) {
        },

        setIsCheckDepositSurvey(state, action: PayloadAction<boolean>) {
            state.isCheckDepositSurvey = action.payload;
        },

        sendDepositSurveyResultStartAction(state, action: PayloadAction<ISendDepositSurveyActionPayload>) {
        },
        sendDepositSurveyResultSuccess(state, action: PayloadAction) {
        },
        sendDepositSurveyResultFailure(state, action: PayloadAction) {
        },

        setDepositStepAction(state, action: PayloadAction<TDepositStep>) {
            state.step = action.payload;
        },

        resetDepositTransferParams(state, action: PayloadAction) {
            state.step = initialState.step;
            state.depositCreateSuccessPayload = null;
        },

        resetDepositError(state, action: PayloadAction) {
            state.error = null;
        },

        setIncompleteDepositVisible(state, action: PayloadAction<boolean>) {
            state.isIncompleteDepositVisible = action.payload;
        },
        setIsIncompleteDepositClosedByUser(state, action: PayloadAction<boolean>) {
            state.isIncompleteDepositClosedByUser = action.payload;
        },
        setIncompleteDeposit(state, action: PayloadAction<Partial<IDepositState['incompleteDeposit']>>) {
            state.incompleteDeposit = {
                ...state.incompleteDeposit,
                ...action.payload,
            };
        },
    },
    extraReducers: (builder) => {
        builder.addCase(LOGOUT_SUCCESS, () => {
            return {
                ...initialState,
            };
        });
    },
});

export const {
    deleteDepositFormUserDataAction,
    deleteDepositFormUserDataFailure,
    deleteDepositFormUserDataSuccess,
    depositCreateAction,
    depositCreateFailure,
    depositCreateSuccess,
    depositInitAction,
    depositUnmountAction,
    getDepositAvailableMethodsAction,
    getDepositAvailableMethodsFailure,
    getDepositAvailableMethodsSuccess,
    getDepositFormAction,
    getDepositFormDataListAction,
    getDepositFormDataListFailure,
    getDepositFormDataListSuccess,
    getDepositFormFailure,
    getDepositFormSuccess,
    getDepositFormUserDataAction,
    getDepositFormUserDataFailure,
    getDepositFormUserDataSuccess,
    getDepositParamsAction,
    getDepositParamsFailure,
    getDepositParamsSuccess,
    getDepositSurveyAction,
    getDepositSurveyFailure,
    getDepositSurveySuccess,
    handleDepositFormUnmountAction,
    initDepositPaymentFormAction,
    sendDepositSurveyResultFailure,
    sendDepositSurveyResultStartAction,
    sendDepositSurveyResultSuccess,
    setDepositFormUserDataAction,
    setDepositFormUserDataFailure,
    setDepositFormUserDataSuccess,
    setDepositStepAction,
    setIsCheckDepositSurvey,
    setIncompleteDepositVisible,
    setIsIncompleteDepositClosedByUser,
    setIncompleteDeposit,
    updateDepositTransactionAction,
    updateDepositTransactionFailure,
    updateDepositTransactionSuccess,
    resetDepositTransferParams,
    resetDepositError,
} = depositSlice.actions;

export default depositSlice.reducer;
